import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noFiltersMessage: {
		id: 'polaris-component-collection-configure-sidebar.default-content.filters.no-filters-message',
		defaultMessage: 'There aren’t any filters applied to this roadmap.',
		description: 'Message displayed when no filters is defined in the roadmap',
	},
});
